import React, { useState, useEffect } from 'react';
import { Share } from 'lucide-react';

const IOSInstallPrompt = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Detect iOS Safari (not in standalone mode already)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isStandalone = window.navigator.standalone === true;
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome|CriOS|FxiOS/.test(navigator.userAgent);
    const dismissed = localStorage.getItem('ios_install_dismissed');

    if (isIOS && !isStandalone && isSafari && !dismissed) {
      // Delay showing to avoid interrupting page load
      const timer = setTimeout(() => setShow(true), 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  if (!show) return null;

  const handleDismiss = () => {
    localStorage.setItem('ios_install_dismissed', 'true');
    setShow(false);
  };

  return (
    <div className="fixed bottom-20 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom sm:bottom-0" data-testid="ios-install-prompt">
      <div className="max-w-md mx-auto bg-white rounded-2xl shadow-2xl border border-gray-200 p-4">
        <div className="flex items-start gap-3">
          <div className="bg-[#1e3a5f] rounded-xl p-2 flex-shrink-0">
            <img 
              src="/icon-192.png" 
              alt="App icon" 
              className="w-10 h-10 rounded-lg"
            />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-gray-900 text-sm">Install Truckn Send It</p>
            <p className="text-xs text-gray-600 mt-1">
              Add this app to your home screen: tap 
              <Share className="w-3.5 h-3.5 inline mx-1 text-blue-600 -mt-0.5" />
              then <strong>"Add to Home Screen"</strong>
            </p>
          </div>
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-600 text-lg font-bold flex-shrink-0 leading-none"
            aria-label="Dismiss"
          >
            &times;
          </button>
        </div>
      </div>
    </div>
  );
};

export default IOSInstallPrompt;
